import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { Member } from '../domain/member';

const initialState: Member = {
    accesses: [],
    expiration: '',
    start: '',
    user: '',
};

const groupSlice = createSlice({
    initialState,
    name: 'member',
    reducers: {

        clearMember: () =>
            initialState // Replace the state with the new group
        ,
        setMember: (state, action: PayloadAction<Member>) => {
            return action.payload; // Replace the state with the new group
        },
        updateMemberProps: (state, action: PayloadAction<Member>) =>
            ({ ...state, ...action.payload }) // Clear the state 
        ,
    },
});

export const { setMember, clearMember, updateMemberProps } = groupSlice.actions;
export default groupSlice.reducer;